import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AnnouncementForm,
  TechnicalInstallation
} from '../model/technical-installations.model';
import { BUILDINGS_BASE_URI } from './building.service';

@Injectable({
  providedIn: 'root',
})
export class TechnicalInstallationService {
  constructor(private readonly http: HttpClient) {}

  announce(buildingId: number, form: AnnouncementForm): Observable<TechnicalInstallation> {
    return this.http.post<TechnicalInstallation>(this.getBaseUrl(buildingId), form);
  }

  updateAnnouncement(buildingId: number, installationId: number, form: TechnicalInstallation): Observable<TechnicalInstallation> {
    return this.http.put<TechnicalInstallation>(this.getBaseUrl(buildingId, installationId), form);
  }

  getInstallations(buildingId: number): Observable<TechnicalInstallation[]> {
    return this.http.get<TechnicalInstallation[]>(this.getBaseUrl(buildingId));
  }

  getBaseUrl(buildingId: number, installationId?: number): string {
    const itechId = installationId == null ? '' : `/${installationId}`;
    return `${BUILDINGS_BASE_URI}/${buildingId}/technical-installations${itechId}`;
  }
}
